// src/temas/temas-config.ts
export const TEMAS_APP = {
  MODERNO_BLUE: { 
    primary: '#2563eb', 
    secondary: '#60a5fa', 
    background: '#f8fafc', 
    surface: '#ffffff', 
    text: '#1e293b' 
  },
  ELEGANT_GOLD: { 
    primary: '#846733', 
    secondary: '#c5a059', 
    background: '#fafaf9', 
    surface: '#ffffff', 
    text: '#1c1917' 
  },
  NATURE_GREEN: { 
    primary: '#166534', 
    secondary: '#4ade80', 
    background: '#f0fdf4', 
    surface: '#ffffff', 
    text: '#14532d' 
  },
  VIBRANT_PURPLE: { 
    primary: '#7c3aed', 
    secondary: '#a78bfa', 
    background: '#f5f3ff', 
    surface: '#ffffff', 
    text: '#2e1065' 
  },
  SOFT_ROSE: { 
    primary: '#e11d48', 
    secondary: '#fb7185', 
    background: '#fff1f2', 
    surface: '#ffffff', 
    text: '#4c0519' 
  },
  // NOVO TEMA: Preto e Branco (Dark)
  DARK_MINIMAL: { 
    primary: '#0c0c0c',     // Botões e destaques em branco
    secondary: '#a1a1aa',   // Cinza para elementos secundários
    background: '#fafafa',  // Fundo quase preto (padrão Zinc/Slate)
    surface: '#fafafa',     // Cards e papéis em cinza muito escuro
    text: '#18181b'         // Texto em branco puro/gelo
  }
} as const;

export type ThemeType = keyof typeof TEMAS_APP;